import apiClient from "./apiClient";

const employeesApi = {
  createEmployee: async (branchId, email) => {
    const response = await apiClient.post("/employees/employees", { branchId, email });
    return response.data;
  },

  batchCreateEmployees: async (branchId, file) => {
    const formData = new FormData();
    formData.append("branchId", branchId);
    formData.append("file", file);
    const response = await apiClient.post("/employees/employees/batch", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  getEmployeeById: async (employeeId) => {
    const response = await apiClient.get(`/employees/employees/${employeeId}`);
    return response.data;
  },

  updateEmployee: async (employeeId, email) => {
    const response = await apiClient.put(`/employees/employees/${employeeId}`, { email });
    return response.data;
  },

  deleteEmployee: async (employeeId) => {
    const response = await apiClient.delete(`/employees/employees/${employeeId}`);
    return response.data;
  },

  getNomApplicationEmployees: async (applicationId, options = {}) => {
    const response = await apiClient.get(
      `/employees/nom-applications/${applicationId}/employees`,
      { params: { page: options.page || 1, pageSize: options.pageSize || 100 } }
    );
    return response.data;
  },

  createNomApplicationEmployee: async (applicationId, employee) => {
    const response = await apiClient.post(
      `/employees/nom-applications/${applicationId}/employees`,
      typeof employee === "string" ? { email: employee } : employee
    );
    return response.data;
  },

  updateNomApplicationEmployee: async (applicationId, employeeId, employee) => {
    const response = await apiClient.put(
      `/employees/nom-applications/${applicationId}/employees/${employeeId}`,
      typeof employee === "string" ? { email: employee } : employee
    );
    return response.data;
  },

  deleteNomApplicationEmployee: async (applicationId, employeeId) => {
    const response = await apiClient.delete(
      `/employees/nom-applications/${applicationId}/employees/${employeeId}`
    );
    return response.data;
  },

  // Por branch (nuevo)
  getEmployeeCountByBranch: async (branchId) => {
    const response = await apiClient.get(`/employees/branches/${branchId}/employees/count`);
    return response.data.count;
  },

  getEmployeesByBranch: async (branchId, options = {}) => {
    const params = {};
    if (options.answeredHra      !== undefined) params.answeredHra      = options.answeredHra;
    if (options.answeredBurnout  !== undefined) params.answeredBurnout  = options.answeredBurnout;
    if (options.page             !== undefined) params.page             = options.page;
    if (options.pageSize         !== undefined) params.pageSize         = options.pageSize;
    if (options.sortBy           !== undefined) params.sortBy           = options.sortBy;
    if (options.sortOrder        !== undefined) params.sortOrder        = options.sortOrder;
    const response = await apiClient.get(`/employees/branches/${branchId}/employees`, { params });
    return response.data;
  },

  // Por company (backward compat — para dashboards y analytics existentes)
  getEmployeeCount: async (companyId) => {
    const response = await apiClient.get(`/employees/companies/${companyId}/employees/count`);
    return response.data.count;
  },

  getEmployeesByCompany: async (companyId, options = {}) => {
    const params = {};
    if (options.answeredHra      !== undefined) params.answeredHra      = options.answeredHra;
    if (options.answeredBurnout  !== undefined) params.answeredBurnout  = options.answeredBurnout;
    if (options.page             !== undefined) params.page             = options.page;
    if (options.pageSize         !== undefined) params.pageSize         = options.pageSize;
    if (options.sortBy           !== undefined) params.sortBy           = options.sortBy;
    if (options.sortOrder        !== undefined) params.sortOrder        = options.sortOrder;
    const response = await apiClient.get(`/employees/companies/${companyId}/employees`, { params });
    return response.data;
  },
};

export default employeesApi;
